import React from "react";
import "../../../../App.css";
import "../../../_Shared/utility.css";
import "./NotFound.css";
import { EUBanner } from "../../../Banner/Banner";
import { cdn } from "../../../../consts/cdn";

//Images
const BannerDesktop = cdn.images + "NotFound/Banner-Desktop-Compressed.jpg";
const BannerMobile = cdn.images + "NotFound/Banner-Mobile.jpg";

function NotFound() {
  return (
    <>
      <div className="notFound-FR">
        <EUBanner
          imgdesktop={BannerDesktop}
          imgmobile={BannerMobile}
          bold1="404"
          text1="Nous ne parvenons pas à trouver la page"
          text2="que vous recherchez."
          buttons={[
            {
              text: "Retour à la page d'accueil",
              route: "/fr",
            },
          ]}
          color="#365B7E"
          openSans="true"
        />
      </div>
    </>
  );
}

export default NotFound;
